import { useCallback, useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { useCrm } from "./CrmContext";
import { Empty } from "./CrmBits";
import { ActivityItem } from "./Timeline";
import { api } from "@/lib/api";

const FILTERS = [["", "Everything"], ["text", "Texts"], ["email", "Emails"], ["call", "Calls"], ["web", "Website activity"], ["note", "Notes"], ["system", "Updates"]];

export const InboxView = () => {
  const { scope, params } = useCrm();
  const [kind, setKind] = useState(params.get("kind") || "");
  const [rows, setRows] = useState(null);
  const [repliesOnly, setRepliesOnly] = useState(false);
  const load = useCallback(() => api.get("/admin/crm/feed", { params: { scope, kind } }).then(({ data }) => setRows(data || [])).catch(() => setRows([])), [scope, kind]);
  useEffect(() => { load(); const id = setInterval(load, 30000); return () => clearInterval(id); }, [load]);
  const shown = (rows || []).filter((a) => !repliesOnly || a.direction === "in");
  return (
    <div className="mx-auto max-w-[980px] space-y-4 p-4 sm:p-6" data-testid="crm-inbox">
      <div className="flex flex-wrap items-center gap-3">
        <div className="mr-auto"><h1 className="text-xl font-semibold tracking-tight sm:text-2xl">Inbox & live activity</h1><p className="text-[12.5px] text-[#64748B]">Text replies, emails, calls and website activity across {scope === "all" ? "the firm" : "your people"}. Refreshes every 30 seconds.</p></div>
        <button type="button" onClick={load} className="crm-btn crm-btn-ghost" data-testid="inbox-refresh"><RefreshCw className="h-4 w-4" />Refresh</button>
      </div>
      <div className="flex flex-wrap items-center gap-1.5" data-testid="inbox-filters">
        {FILTERS.map(([id, label]) => <button key={id || "all"} type="button" onClick={() => setKind(id)} className={`rounded-full px-3 py-1 text-[12.5px] ${kind === id ? "bg-[#3A4553] text-white" : "bg-white text-[#475569] ring-1 ring-[#E2E8F0]"}`} data-testid={`inbox-filter-${id || "all"}`}>{label}</button>)}
        <label className="ml-auto flex items-center gap-2 text-[12.5px]"><input type="checkbox" checked={repliesOnly} onChange={(e) => setRepliesOnly(e.target.checked)} data-testid="inbox-replies-only" />Replies only</label>
      </div>
      <div className="crm-card px-4" data-testid="inbox-list">
        {rows === null ? <Empty testId="inbox-loading">Loading…</Empty> : shown.length ? shown.map((a) => <ActivityItem key={a.id} activity={a} compact />) : <Empty testId="inbox-empty">No activity yet.</Empty>}
      </div>
    </div>
  );
};
